/**
 *
 *
 * 根计算属性 getters
 *
*/
export default  {
  /**
   *
   *
   * 系统奔溃tost弹框过滤
  */
  systemResidueTost: state => {
    const { residue } = state.system_error_data
    if (residue === 0 ) {
      return '行啦,不能再催了'
    } else if(residue === 1) {
      return '老板别慌，马上胜利'
    } else {
      return '知道了，小主，快马加鞭'
    }
  }
}